import { render, staticRenderFns } from "./cv-header-side-nav-items.vue?vue&type=template&id=9977d666&"
import script from "./cv-header-side-nav-items.vue?vue&type=script&lang=js&"
export * from "./cv-header-side-nav-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports